import { TAccount } from './accounts.types';

export const getAccountIsRCF = (account: TAccount) => {
    if (!account.formal_offer_access_period) return false;

    return account.formal_offer_access_period.interest_only_repayments === 12;
};
